import React,{useState,useEffect} from 'react';
import {useParams,Route,Routes,Navigate} from 'react-router-dom';
import Landing from '../landing/landing';
import Auth from '../auth/auth';
import TranslatorPage from '../translator-page/translator-page';
import Pricing from '../pricing/pricing';
import About from '../about/about';
import Contact from '../contact/contact';
import TermsOfService from '../terms-of-service/terms-of-service';
import PrivacyPolicy from '../privacy-policy/privacy-policy';
import PaymentSuccess from '../payment-success/payment-success';
import Unsubber from '../unsubber/unsubber';
import eventManagerUtil from '../../utils/event-manager-util';
import globalSettingsManagerUtil from '../../utils/global-settings-manager-util';
import isOrganicUtil from '../../utils/is-organic-util';
import langMap from '../../constants/lang-map';
import config from '../../constants/config';
const LocalizedRoutes=()=>{
  let [globalSettings,setGlobalSettings]=useState(globalSettingsManagerUtil.getGlobalSettings());
  let {lang}=useParams();
  useEffect(()=>{
    const family={
      'ja':'Noto+Sans+JP',
      'zh':'Noto+Sans+SC',
      'ko':'Noto+Sans+KR',
    }[globalSettings.lang];
    if(!(config.ENABLE_EXTERNAL_FONTS&&family&&isOrganicUtil())){
      return;
    }
    const linkId=`cjk-font-${globalSettings.lang}`;
    let linkElem=document.getElementById(linkId);
    if(linkElem){
      return;
    }
    linkElem=document.createElement('link');
    linkElem.id=linkId;
    linkElem.rel='stylesheet';
    linkElem.href=`https://fonts.googleapis.com/css2?family=${family}:wght@100..900&display=swap`;
    document.head.appendChild(linkElem);
  },[globalSettings.lang]);
  useEffect(()=>{
    if(!window.Paddle){
      return;
    }
    Paddle.Update({
      pwCustomer:(globalSettings.user?.cust_id?{id:globalSettings.user.cust_id}:{}),
    });
  },[globalSettings.user,window.Paddle]);
  eventManagerUtil.deleteAllAndNewEvent('update-global-settings-app',(newGlobalSettings)=>{
    setGlobalSettings({...newGlobalSettings});
  });
  if(globalSettings.lang!==lang){
    if(lang!=='auto'&&Object.keys(langMap).includes(lang)){
      globalSettingsManagerUtil.updateGlobalSettings({lang});
    }
    else{
      return <Navigate to={`/${globalSettings.lang}${window.location.pathname}${window.location.hash}`} />;
    }
  }
  return (
    <Routes>
      <Route
        path='/'
        element={
          <Landing
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/login'
        element={
          <Auth
            isLogin={true}
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/register'
        element={
          <Auth
            isLogin={false}
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/translator'
        element={
          <TranslatorPage
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/pricing'
        element={
          <Pricing
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/about'
        element={
          <About
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/contact'
        element={
          <Contact
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/terms-of-service'
        element={
          <TermsOfService
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/privacy-policy'
        element={
          <PrivacyPolicy
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/payment-success'
        element={
          <PaymentSuccess
            globalSettings={globalSettings}
          />
        }
      />
      <Route
        path='/unsubscribe'
        element={
          <Unsubber
            globalSettings={globalSettings}
          />
        }
      />
    </Routes>
  );
};
export default LocalizedRoutes;

